import EditUserContainer from './EditUserContainer'
import EditUser from './EditUser'
export { EditUser }
export { EditUserContainer }
export default EditUserContainer



// WEBPACK FOOTER //
// ./src/pages/EditUser/index.js